import {Injectable} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {from, Observable} from 'rxjs';
import {MessageDialogComponent} from './message-dialog.component';

export type MessageDialogType = 'success' | 'error' | 'warning' | 'info';

export interface MessageDialogSetting {
  type?: MessageDialogType;
  title?: string;
  content: string;
  confirmButtonMsg?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MessageDialogService {

  constructor(private modalService: NgbModal) {
  }

  open(setting: MessageDialogSetting): Observable<boolean> {
    const modalRef = this.modalService.open(MessageDialogComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      windowClass: 'app-message-dialog',
      modalDialogClass: 'modal-dialog-centered'
    });

    const component = modalRef.componentInstance as MessageDialogComponent;
    component.type = setting.type;
    component.content = setting.content;

    if (setting.title) {
      component.title = setting.title;
    }

    if (setting.confirmButtonMsg) {
      component.confirmButtonMsg = setting.confirmButtonMsg;
    }

    return from(modalRef.result);
  }
}
